import * as React from 'react';

import type { FieldBehaviorFilterBlockDropdownSection, FieldBehaviorFilterFormModel } from 'af-root/scenes/Company/Settings/Reports/Shared/formModel';

interface WithFieldBehaviorFilter {
	useFieldBehaviorFilter: true;
	fieldBehaviorFilterOptions: FieldBehaviorFilterBlockDropdownSection<Pick<FieldBehaviorFilterFormModel, 'reportBlockFieldToFilterByVirtualId'>>[];
	fieldBehaviorFilterValuesMap: Record<string, string[]>;
}

interface WithoutFieldBehaviorFilter {
	useFieldBehaviorFilter?: false;
}

export type FieldBehaviorFilterContextValue = WithFieldBehaviorFilter | WithoutFieldBehaviorFilter;

const FieldBehaviorFilterContext = React.createContext<FieldBehaviorFilterContextValue>({
	useFieldBehaviorFilter: false,
});

export function FieldBehaviorFilterProvider({
	value,
	children,
}: {
	value: FieldBehaviorFilterContextValue;
	children: React.ReactNode;
}) {
	return (
		<FieldBehaviorFilterContext.Provider value={value}>
			{children}
		</FieldBehaviorFilterContext.Provider>
	);
}

export function useFieldBehaviorFilterContext() {
	return React.useContext(FieldBehaviorFilterContext);
}
